import React, { useState, useEffect } from "react";
import { FiSearch, FiBell, FiStar, FiAlertCircle } from "react-icons/fi";
import { useData } from "../../contexts/DataContext";
import { formatDistanceToNow } from "date-fns";

export default function StudentNotices() {
  const { getNotices } = useData();
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState("");
  const [filter, setFilter]   = useState("all");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getNotices({ audience: "students" }).then(d => { setNotices(d); setLoading(false); }); }, []);

  const filtered = notices.filter(n =>
    (filter === "all" || n.priority === filter) &&
    (n.title.toLowerCase().includes(search.toLowerCase()) || n.content.toLowerCase().includes(search.toLowerCase()))
  );

  const pinned  = filtered.filter(n => n.pinned);
  const regular = filtered.filter(n => !n.pinned);

  return (
    <div className="fade-in">
      <div className="page-head">
        <div><h1 className="page-title">🔔 School Notices</h1><p className="page-subtitle">{filtered.length} announcements</p></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 20, flexWrap: "wrap" }}>
        <div className="search-box" style={{ flex: 1 }}>
          <FiSearch className="search-icon" size={14} />
          <input placeholder="Search notices…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {["all","high","normal"].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{
            padding: "7px 14px", borderRadius: "var(--r6)", border: `1.5px solid ${filter===f?"var(--blue-700)":"var(--border)"}`,
            background: filter===f?"var(--blue-700)":"#fff", color: filter===f?"#fff":"var(--gray-500)",
            fontWeight: 600, fontSize: ".82rem", cursor: "pointer", fontFamily: "Inter,sans-serif",
          }}>
            {f === "all" ? "All" : f === "high" ? "Important" : "General"}
          </button>
        ))}
      </div>

      {loading ? <div className="loading-center"><div className="spinner" /></div> : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {pinned.length > 0 && (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                <FiStar size={13} style={{ color: "var(--amber-600)" }} />
                <span style={{ fontSize: ".72rem", fontWeight: 700, color: "var(--gray-500)", textTransform: "uppercase", letterSpacing: ".8px" }}>Pinned</span>
              </div>
              {pinned.map(n => <NoticeItem key={n.id} n={n} />)}
              <div className="divider" />
            </>
          )}
          {regular.map(n => <NoticeItem key={n.id} n={n} />)}
          {filtered.length === 0 && (
            <div className="card"><div className="empty-state"><div className="empty-icon">🔔</div><div className="empty-title">No notices</div><div className="empty-desc">No announcements right now.</div></div></div>
          )}
        </div>
      )}
    </div>
  );
}

function NoticeItem({ n }) {
  const isHigh = n.priority === "high";
  return (
    <div style={{
      background: "#fff", borderRadius: "var(--r8)",
      border: `1px solid ${isHigh ? "#fca5a5" : "var(--border)"}`,
      borderLeft: `4px solid ${isHigh ? "var(--red-600)" : "var(--blue-700)"}`,
      padding: "14px 16px",
    }}>
      <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
        <div style={{ width: 32, height: 32, borderRadius: "var(--r6)", background: isHigh ? "var(--red-50)" : "var(--blue-50)", color: isHigh ? "var(--red-600)" : "var(--blue-700)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          {isHigh ? <FiAlertCircle size={14} /> : <FiBell size={14} />}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 5 }}>
            <h4 style={{ fontSize: ".9rem", fontWeight: 700, color: "var(--gray-900)" }}>{n.title}</h4>
            {n.pinned && <span className="badge badge-amber" style={{ fontSize: ".65rem" }}>📌 Pinned</span>}
            <span className={`badge ${isHigh ? "badge-red" : "badge-blue"}`} style={{ fontSize: ".65rem" }}>
              {isHigh ? "Important" : "General"}
            </span>
          </div>
          <p style={{ fontSize: ".84rem", color: "var(--gray-700)", lineHeight: 1.65, marginBottom: 8 }}>{n.content}</p>
          <div style={{ fontSize: ".73rem", color: "var(--gray-400)", display: "flex", gap: 12 }}>
            <span>By {n.author}</span>
            <span>{n.createdAt ? formatDistanceToNow(new Date(n.createdAt), { addSuffix: true }) : ""}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
